import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BillingTenant } from "@/components/settings/BillingTenant";

export function Paywall() {
  const { user } = useAuth();
  return (
    <div className="mx-auto max-w-3xl space-y-6" data-testid="paywall-screen">
      <div className="rounded-2xl border border-[#EF4444]/30 bg-[#EF4444]/[0.06] p-8 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#EF4444]/15">
          <Lock className="h-6 w-6 text-[#EF4444]" strokeWidth={1.5} />
        </div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-foreground">Subscription expired</h1>
        <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
          {user?.tenant_name ? `${user.tenant_name}'s` : "Your"} subscription has ended. Renew below to restore
          full access to the platform. You can still view your plan, payment details and history.
        </p>
        <Link to="/settings?tab=billing" className="mt-1 inline-block text-xs text-muted-foreground underline-offset-4 hover:underline">
          Manage in Settings → Billing
        </Link>
      </div>
      <BillingTenant />
    </div>
  );
}
